import { ssoClient } from "./sso-client";
import { useAuthStore } from "../stores/auth-store";
import { stopRefreshTimer } from "./token-refresh";

export function logout() {
  const { idToken } = useAuthStore.getState();
  stopRefreshTimer();

  if (ssoClient) {
    ssoClient.logout(idToken ?? undefined);
  } else {
    useAuthStore.getState().clearTokens();
    window.location.href = "/sso/login";
  }
}
